export const ucf_valid_email_extensions = [
    'ucf.edu',
    'knights.ucf.edu',
    'cs.ucf.edu',
    'eecs.ucf.edu',
    'ist.ucf.edu',
    'creol.ucf.edu',
    'physics.ucf.edu',
    'math.ucf.edu',
    'sciences.ucf.edu',
    'business.ucf.edu',
    'cecs.ucf.edu',
    'healthprofessions.ucf.edu',
    'medicine.ucf.edu',
    'nursing.ucf.edu',
    'hospitality.ucf.edu',
    'education.ucf.edu',
    'arts.ucf.edu',
    'graduate.ucf.edu',
    'honors.ucf.edu',
    'global.ucf.edu',
    'library.ucf.edu',
    'admissions.ucf.edu',
    'registrar.ucf.edu',
    'residency.ucf.edu',
    'residencyreview.ucf.edu',
    'gradreclass.ucf.edu',
    'studenthealth.ucf.edu',
    'police.ucf.edu',
    'housing.ucf.edu',
    'financialaid.ucf.edu',

    // Add more emails extensions here
];